import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';

import * as firebase from 'firebase'
import sortBy from 'lodash.sortby';

import { getProductPage } from '../../actions/productActions';
import { deleteAllProductsFromFirebase } from '../../utils/productService';
import {
  Header,
  PaginationContainer
} from '../Styles/index';
import ProductsTable from './ProductsTable';
import LoadingState from '../Loading';
import ProductSearchResults from './ProductSearchResults';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import Dialog from 'material-ui/Dialog';
const flatButtonStyle = {
  minWidth: 36
};

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 32px 16px;
`
const TableContainer = styled.div`

`

const Warning = styled.div`
  background-color: rgba(244, 67, 54,.25);
  padding: 16px;
  color: #C62828;
  border-radius: 4px;
  margin-bottom: 24px
`

const PreviousPageLink = ({isActive, onClick}) => (
  <RaisedButton primary style={flatButtonStyle} icon={<NavigationChevronLeft/>} onClick={onClick} disabled={!isActive}/>
);

const NextPageLink = ({isActive, onClick}) => (
  <RaisedButton primary style={flatButtonStyle} icon={<NavigationChevronRight/>} onClick={onClick} disabled={!isActive}/>
);

const DeleteAllDialog = (props) => (
  <Dialog
    title="Delete All Product"
    actions={props.actions}
    modal={false}
    open={props.open}
    onRequestClose={props.handleClose}
  >
    <Warning>
      After you delete all products, it's permanently deleted. Products can't be undeleted.
    </Warning>
  </Dialog>
)

class ProductList extends Component {

  state = {
    loading: false,
    currentPage: 0,
    limit: 31,
    products: [],
    activeProducts: [],
    orderBy: 'order-by',
    orderByItems: [ 'product_name', 'product_quantity', 'price_item', 'pcscase', 'zbritje', 'skadenca', 'categories', 'pa' ],
    showTable: true,
    activeFilter: false,
    searchResults: [],
    searchQuery: '',
    openDialog: false,
  }

  _handleSearchChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value.trim()
    });

    if (event.target.value.trim() === '') {
      this.setState({
        showTable: true
      })
    } else {
      this._handleSearch(event.target.value.trim());
    }
  }

  _handleSearchSubmit = (event) => {
    event.preventDefault();
    this._handleSearch(this.state.searchQuery);
  }

  _handleSearch(query){
    this._searchProduct(query, 'product_name', (productList) => {
      console.log('productList1', productList)
      if(!productList) {
        return this._searchProduct(query, 'product_name_lower', (productList2) => {   
          console.log('productList2', productList2)       
          this._updateSearchResults(productList2 || [])
        })
      }

      this._updateSearchResults(productList)
    })

    // firebase.database().ref().child('products')
    // .orderByChild('product_name').startAt(query).endAt(`${query}\uf8ff`)
    // .on('value', snapshot => {
    //   const productList = [];
    //   snapshot.forEach(product => {
    //     productList.push({ ...product.val(), key: product.key });
    //   })
    //   this.setState({
    //     searchResults: productList 
    //   },() => {
    //     console.log(this.state.searchResults)
    //     this.setState({
    //       showTable: false
    //     })
    //   });
    // })
  }

  _updateSearchResults(searchResults = []) {
    this.setState({
      searchResults 
    },() => {
      console.log(this.state.searchResults)
      this.setState({
        showTable: false
      })
    });
  }

  _searchProduct(query, field, onResult = () => {}) {
    firebase.database().ref().child('products')
    .orderByChild(field).startAt(query).endAt(`${query}\uf8ff`)
    .on('value', snapshot => {
      const productList = [];
      snapshot.forEach(product => {
        productList.push({ ...product.val(), key: product.key });
      })
      console.log({productList})
      if(!productList.length) {
        return onResult(false)
      }

      return onResult(productList)
    })
  }

  _handleSearchBack = (event) => {
    this.setState({
      searchResults: [],
      showTable: true,
      searchQuery: ''
    })
  }

  _handleChange = (event, index, value) => {
    let products;
    let activeProducts;
    if (value !== 'skadenca') {
      products = sortBy(this.state.products, [value]);
      activeProducts = sortBy(this.state.activeProducts, [value]);
    }else {
      products = sortBy(this.state.products, value =>  new Date(value.skadenca));
      activeProducts = sortBy(this.state.activeProducts, value =>  new Date(value.skadenca));
    }

    this.setState({
      orderBy: value,
      products,
      activeProducts
    });
  }

  _goToEditPage = (code) => {
    this.props.history.push(`/products/edit?product-code=${code}`);
  }

  _refreshPage = () => {
    if (this.state.products.length <= 1) {
      this.setState({
        currentPage: 0,
      })
    }

    this.props.getProductPage({limit: this.state.limit, page: this.state.currentPage})
    .then(_ => {
      if (this.props.products.status === 'fetched') {
        this._updateProducts(this.state.currentPage)
      }
    });
  }

  _updateProducts(currentPage) {
    if (this.props.products.status === 'fetched') {
      const pages = Object.keys(this.props.products.data);
      const products = this.props.products.data[pages[currentPage]];
      console.log({products})
      this.setState({
        products,
        pages: pages,
        activeProducts: products.filter(product => product.is_active === true),
        currentPage
      })
    }
  }

  _handlePrevPage = (event) => {
    const page = this.state.currentPage > 0 ? this.state.currentPage - 1 : 0;
    this._updateProducts(page);
  }

  _handleNextPage = async (event) => {
    await this.props.getProductPage({ limit: this.state.limit });
    this._updateProducts(this.state.currentPage + 1);
  }

  async componentDidMount() {
    await this.props.getProductPage({ limit: this.state.limit });
    this._updateProducts(0);
  }

  _handleDialogCloseRequest = event => {
    this.setState({
      openDialog: false,
    })
  }

  _handleDialogOpenRequest = (event) => {
    this.setState({
      openDialog: true
    })
  }

  _handleDeleteAllProduct = async event => {
    event.preventDefault();
    this.setState({
      loading: true,
    })
    const token = localStorage.getItem('jwtToken');
    await deleteAllProductsFromFirebase(token);
    this.setState({
      openDialog: false,
    });
    await this.props.getProductPage({ limit: this.state.limit, reset: true });
    this._updateProducts(0);
    this.setState({
      loading: false,
    })
  }

  _dialogActions(){
    return [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this._handleDialogCloseRequest}
      />,
      <form style={{display: 'inline-block'}} onSubmit={this._handleDeleteAllProduct}>
        <RaisedButton
          label="Delete"
          type="submit"
          backgroundColor="#F44336"
          labelStyle={{ color: 'white' }}
        />
      </form>,
    ]
  }

  render(){
    const tableHeader = ['No', 'Product Code', 'Product Name', 'pcscase', 'Product Quantity', 'Price Item', 'Rimbursimi', 'pa', 'Categories', 'Zbritje', 'Tvsh', 'Skadenca', 'Parent Category', ''];
    return(
      <Container>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            {!this.state.showTable &&
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                label="Back"
                onTouchTap={this._handleSearchBack}
                icon={<NavigationArrowBack />}
              />
            }
            {this.state.showTable && <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              <MenuItem key={"order-by"} value={"order-by"} primaryText={"Sort By"}/>
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>}
          </div>
          <div style={{padding: '16px 24px 16px 0'}}>
            {this.state.showTable && 
              <RaisedButton
                labelStyle={{ color: 'white'}}
                style={flatButtonStyle} 
                backgroundColor="#F44336"
                label="Delete all products" 
                onTouchTap={this._handleDialogOpenRequest}
              />
            }
          </div>
          <div style={{padding: '16px 24px 16px 0'}}>
            
            {this.state.showTable && <Checkbox
              checked={this.state.activeFilter}
              onCheck={(event, checked) => {
                this.setState({
                  activeFilter: checked
                });
              }}
              label="Active"
            />}
          </div>
          <div>
            <form onSubmit={this._handleSearchSubmit}>
              <TextField
                name="searchQuery"
                id="searchQuery"
                onChange={this._handleSearchChange}
                value={this.state.searchQuery}
                hintText="Search products"
              />
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                icon={<ActionSearch />}
              />
            </form>
          </div>
        </Header>
        {this.props.products.loading
          ? <LoadingState/>
          : <div>
            { this.state.showTable &&
              <div>
                <PaginationContainer style={{ justifyContent: 'flex-end'}}>
                  <PreviousPageLink  isActive={(this.state.currentPage !== 0)} onClick={this._handlePrevPage}/>
                  <div style={{ width: '16px' }}></div>
                  <NextPageLink isActive={_.last(this.state.pages) !== '__lastPage__'} onClick={this._handleNextPage}/>
                </PaginationContainer>
                <TableContainer>
                  <ProductsTable 
                    refreshPage={this._refreshPage} 
                    editHandler={this._goToEditPage} 
                    headers={tableHeader} 
                    tableData={this.state.activeFilter ? this.state.activeProducts : this.state.products } 
                    height={(this.state.limit-1)*48}
                  /> 
                  
                </TableContainer>
                <div style={{ height: '24px' }}></div>
                <PaginationContainer>
                  <PreviousPageLink  isActive={(this.state.currentPage !== 0)} onClick={this._handlePrevPage}/>
                  <div style={{ width: '16px' }}></div>
                  <NextPageLink isActive={_.last(this.state.pages) !== '__lastPage__'} onClick={this._handleNextPage}/>
                </PaginationContainer>
              </div>
            }
            { !this.state.showTable &&
              <div>
                <ProductSearchResults 
                  refreshPage={this._refreshPage} 
                  goToEditPage={this._goToEditPage} 
                  query={this.state.searchQuery} 
                  products={this.state.searchResults}
                />
              </div>
            }
          </div>
        }
        <div>
          {this.state.loading && <LoadingState />}
          <DeleteAllDialog
            open={this.state.openDialog}
            actions={this._dialogActions()}
            handleClose={this._handleDialogCloseRequest}
          ></DeleteAllDialog>
        </div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({ products: state.product.products });
const mapDispatchToProps = { getProductPage };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductList));



// WEBPACK FOOTER //
// ./src/components/Products/ProductList.js